import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from 'base-submit-petition-library';
import { BaseSubmitPetitionLibraryService } from 'base-submit-petition-library';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'dirty-check-store';
import * as i6 from 'app-services-library';
import * as i7 from '@angular/common';
import * as i8 from '@angular/forms';
import * as i9 from 'primeng/dropdown';
import * as i10 from 'primeng/inputtext';
import * as i11 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import * as i12 from 'primeng/button';
import * as i13 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i14 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i15 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i16 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { PrimengLibraryModule } from 'primeng-library';

class SubmitPetitionLibraryService {
    constructor() { }
}
SubmitPetitionLibraryService.ɵfac = function SubmitPetitionLibraryService_Factory(t) { return new (t || SubmitPetitionLibraryService)(); };
SubmitPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: SubmitPetitionLibraryService, factory: SubmitPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubmitPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["submitPetitionForm"];
function SubmitPetitionLibraryComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r8.inputData.caseType != "I130" ? ctx_r8.inputData.visatype : ctx_r8.inputData.caseType)("stepDetails", ctx_r8.stepDetails)("isViewMode", ctx_r8.inputData["isViewMode"])("isCaseRequest", ctx_r8.inputData["isCaseRequest"]);
} }
const _c1 = function (a0) { return { "layoutCode": a0 }; };
function SubmitPetitionLibraryComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "lib-maximize-dialog-library", 31);
    i0.ɵɵelementStart(2, "i", 32);
    i0.ɵɵlistener("click", function SubmitPetitionLibraryComponent_div_1_div_6_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(1, _c1, ctx_r9.inputData == null ? null : ctx_r9.inputData.layoutCode));
} }
function SubmitPetitionLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4, "Submit Petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SubmitPetitionLibraryComponent_div_1_div_5_Template, 2, 4, "div", 26);
    i0.ɵɵtemplate(6, SubmitPetitionLibraryComponent_div_1_div_6_Template, 3, 3, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizardFlag);
} }
function SubmitPetitionLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "div", 34);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4, "Submit Petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 35);
    i0.ɵɵtext(6, "Submit Petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 36);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵelementStart(9, "li", 37);
    i0.ɵɵelement(10, "lib-step-status-update-component-library", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li", 38);
    i0.ɵɵelement(12, "lib-maximize-dialog-library", 31);
    i0.ɵɵelementStart(13, "i", 32);
    i0.ɵɵlistener("click", function SubmitPetitionLibraryComponent_div_2_Template_i_click_13_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.caseType != "I130" ? ctx_r1.inputData.visatype : ctx_r1.inputData.caseType)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c1, ctx_r1.inputData == null ? null : ctx_r1.inputData.layoutCode));
} }
function SubmitPetitionLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 41);
    i0.ɵɵlistener("updateStatus", function SubmitPetitionLibraryComponent_div_3_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r2.inputData.visatype)("stepDetails", ctx_r2.stepDetails)("isViewMode", ctx_r2.inputData["isViewMode"])("isCaseRequest", ctx_r2.inputData["isCaseRequest"]);
} }
function SubmitPetitionLibraryComponent_lib_last_update_library_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 42);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r4.stepDetails)("primaryData", ctx_r4.inputData)("sectionCode", ctx_r4.sectionCode);
} }
function SubmitPetitionLibraryComponent_div_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubmitPetitionLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SubmitPetitionLibraryComponent_div_13_span_1_Template, 2, 1, "span", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r3.controls["submitResponseCode"].errors == null ? null : _r3.controls["submitResponseCode"].errors.required);
} }
function SubmitPetitionLibraryComponent_div_18_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubmitPetitionLibraryComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SubmitPetitionLibraryComponent_div_18_span_1_Template, 2, 1, "span", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r3.controls["submissionAckno"].errors == null ? null : _r3.controls["submissionAckno"].errors.required);
} }
function SubmitPetitionLibraryComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 46);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isViewMode", ctx_r7.inputData["isViewMode"])("isCaseRequest", ctx_r7.inputData["isCaseRequest"])("visaType", ctx_r7.inputData.caseType != "I130" ? ctx_r7.inputData.visatype : ctx_r7.inputData.caseType)("stepDetails", ctx_r7.stepDetails)("type", ctx_r7.typeOfButton)("showPreviousStepBtn", true)("showNextStepBtn", true);
} }
const _c2 = function (a0) { return { hideView: a0 }; };
const _c3 = function (a0) { return { "pl-0": a0 }; };
class SubmitPetitionLibraryComponent extends BaseSubmitPetitionLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, appServicesLibraryService) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.appServicesLibraryService = appServicesLibraryService;
        this.isWizardFlag = false;
        this.onDialogClose = new EventEmitter();
        this.onUpdateStatus = new EventEmitter();
        this.userType = sessionStorage.getItem("userTypeRole");
    }
    ngOnInit() {
        var _a;
        this.isSimplifyH1b = this.simplifyH1b;
        this.isWizard = this.isWizardFlag;
        super.loadInit();
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_SUBMIT_FEES';
        }
        else {
            this.sectionCode = 'SUBMIT_FEES';
        }
        if (this.isWizard) {
            this.onSubmit$.pipe(takeUntil(this.observableSubscription$)).subscribe((res) => {
                if (res) {
                    this.onUpdateStatus.emit();
                }
            });
        }
    }
    ngOnChanges(changes) {
        this.inputData = changes.primaryData.currentValue;
    }
    ngAfterViewInit() {
        this.submitPetitionForm = this.submitPetitionForm;
        this.inputData = this.primaryData;
        super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
SubmitPetitionLibraryComponent.ɵfac = function SubmitPetitionLibraryComponent_Factory(t) { return new (t || SubmitPetitionLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APISubmitPetition), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.DirtyFormGuard), i0.ɵɵdirectiveInject(i6.AppServicesLibraryService)); };
SubmitPetitionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SubmitPetitionLibraryComponent, selectors: [["submit-petition-library"]], viewQuery: function SubmitPetitionLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitPetitionForm = _t.first);
    } }, inputs: { isWizardFlag: "isWizardFlag", primaryData: "primaryData", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose", onUpdateStatus: "onUpdateStatus" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 27, vars: 25, consts: [[1, "container-fuild"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row pt-1  pl-3 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "pt-0", 3, "ngSubmit"], ["submitPetitionForm", "ngForm"], [1, "main-body"], [3, "inputDetails", "primaryData", "sectionCode", 4, "ngIf"], [1, "row", "mb-3"], [1, "col-md-4", "form-group", "processing-dropdown"], [1, "label-cls", "required"], ["name", "submitResponseCode", "optionLabel", "stepResponseName", "optionValue", "stepResponseCode", "placeholder", "Select Status", "required", "", 3, "options", "filter", "ngModel", "disabled", "ngModelChange"], [4, "ngIf"], [1, "col-md-4", "form-group", "input-disabled"], ["type", "text", "name", "submissionAckno", "pInputText", "", "required", "", 1, "im-input", "mw-100", 3, "ngModel", "readOnly", "ngModelChange"], [1, "row", "mb-2"], [2, "width", "100%", 3, "fileUploadConfigurations"], [1, "row", "pt-3", "border-top", 3, "ngClass"], [1, "col-md-6", 3, "ngClass"], [1, "d-flex", "justify-content-start"], ["pButton", "", "type", "submit", "label", "Save", 1, "btn-btn-primary", 3, "ngClass", "disabled"], ["pButton", "", "type", "button", "label", "Cancel", 1, "btn", "btn-primary", 3, "disabled", "click"], ["class", "col-md-6 completeStep", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-9", "step-title", "p-0"], [1, "page-header"], ["class", "col-md-2 editBtn", 4, "ngIf"], ["class", "col-md-1 pr-0 pl-2 d-flex justify-content-end", 4, "ngIf"], [1, "col-md-2", "editBtn"], ["type", "EDIT", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-md-1", "pr-0", "pl-2", "d-flex", "justify-content-end"], [3, "configData"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "row", "pt-1", "pl-3", "d-flex", "align-items-center"], [1, "page-header", "pl-0", "headerPortion"], [1, "m-0"], [1, "col-md-3", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [3, "inputDetails", "primaryData", "sectionCode"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "isViewMode", "isCaseRequest", "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"]], template: function SubmitPetitionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SubmitPetitionLibraryComponent_div_1_Template, 7, 2, "div", 1);
        i0.ɵɵtemplate(2, SubmitPetitionLibraryComponent_div_2_Template, 14, 7, "div", 2);
        i0.ɵɵtemplate(3, SubmitPetitionLibraryComponent_div_3_Template, 3, 4, "div", 3);
        i0.ɵɵelementStart(4, "form", 4, 5);
        i0.ɵɵlistener("ngSubmit", function SubmitPetitionLibraryComponent_Template_form_ngSubmit_4_listener() { return ctx.postsubmitPetition(); });
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, SubmitPetitionLibraryComponent_lib_last_update_library_7_Template, 1, 3, "lib-last-update-library", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelementStart(10, "label", 10);
        i0.ɵɵtext(11, " Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p-dropdown", 11);
        i0.ɵɵlistener("ngModelChange", function SubmitPetitionLibraryComponent_Template_p_dropdown_ngModelChange_12_listener($event) { return ctx.submitPetition.submitResponseCode = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, SubmitPetitionLibraryComponent_div_13_Template, 2, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 13);
        i0.ɵɵelementStart(15, "label", 10);
        i0.ɵɵtext(16, " Acknowledgement number ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "input", 14);
        i0.ɵɵlistener("ngModelChange", function SubmitPetitionLibraryComponent_Template_input_ngModelChange_17_listener($event) { return ctx.submitPetition.submissionAckno = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, SubmitPetitionLibraryComponent_div_18_Template, 2, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵelement(20, "file-upload-library", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 17);
        i0.ɵɵelementStart(22, "div", 18);
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵelement(24, "button", 20);
        i0.ɵɵelementStart(25, "button", 21);
        i0.ɵɵlistener("click", function SubmitPetitionLibraryComponent_Template_button_click_25_listener() { return ctx.handleCancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, SubmitPetitionLibraryComponent_div_26_Template, 2, 7, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b && !ctx.isWizardFlag ? true : false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizardFlag);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx.isWizardFlag ? "noScroll" : "footer-adjust");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizardFlag);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.statusTypeList)("filter", false)("ngModel", ctx.submitPetition.submitResponseCode)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (_r3.controls["submitResponseCode"] == null ? null : _r3.controls["submitResponseCode"].touched) && _r3.controls["submitResponseCode"].invalid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.submitPetition.submissionAckno)("readOnly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (_r3.controls["submissionAckno"] == null ? null : _r3.controls["submissionAckno"].touched) && _r3.controls["submissionAckno"].invalid);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("fileUploadConfigurations", ctx.fileUploadConfigurations);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c2, (ctx.inputData["isViewMode"] || ctx.inputData["isCaseRequest"]) && ctx.userType == "Attorney"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c3, !ctx.isWizardFlag));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", _r3.invalid || ctx.disabledControls ? "mr-3 btn-success_disabled btn btn-primary" : "btn btn-primary mr-3")("disabled", _r3.invalid || ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizardFlag);
    } }, directives: [i7.NgIf, i8.ɵangular_packages_forms_forms_ba, i8.NgControlStatusGroup, i8.NgForm, i9.Dropdown, i8.RequiredValidator, i8.NgControlStatus, i8.NgModel, i8.DefaultValueAccessor, i10.InputText, i11.FileUploadLibraryComponent, i7.NgClass, i12.ButtonDirective, i13.StepStatusUpdateComponentLibraryComponent, i14.MaximizeDialogLibraryComponent, i15.AssigningTaskLibraryComponent, i16.LastUpdateLibraryComponent], styles: [".label-cls[_ngcontent-%COMP%]{color:#626262;font-size:14px}.label-cls[_ngcontent-%COMP%], .readOnly-label[_ngcontent-%COMP%]{font-family:Source Sans Pro,Regular}.readOnly-label[_ngcontent-%COMP%]{width:100%;font-size:16px;color:#000;font-weight:500}.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:18px;font-weight:600;font-family:Source Sans Pro,Semibold}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:2px}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:14px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto}.noScroll[_ngcontent-%COMP%]{height:auto!important}.main-body[_ngcontent-%COMP%]{padding-right:0!important}.headerPortion[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#002e83;font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubmitPetitionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'submit-petition-library',
                templateUrl: 'submit-petition-library.component.html',
                styleUrls: ['submit-petition-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APISubmitPetition }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.AppServicesLibraryService }]; }, { isWizardFlag: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], submitPetitionForm: [{
            type: ViewChild,
            args: ['submitPetitionForm', { static: true }]
        }], simplifyH1b: [{
            type: Input
        }], onUpdateStatus: [{
            type: Output
        }] }); })();

class SubmitPetitionLibraryModule {
}
SubmitPetitionLibraryModule.ɵfac = function SubmitPetitionLibraryModule_Factory(t) { return new (t || SubmitPetitionLibraryModule)(); };
SubmitPetitionLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: SubmitPetitionLibraryModule });
SubmitPetitionLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseSubmitPetitionLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FileUploadLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubmitPetitionLibraryModule, { declarations: [SubmitPetitionLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FileUploadLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule], exports: [SubmitPetitionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubmitPetitionLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [SubmitPetitionLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FileUploadLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule
                ],
                providers: [BaseSubmitPetitionLibraryService],
                exports: [SubmitPetitionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of submit-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SubmitPetitionLibraryComponent, SubmitPetitionLibraryModule, SubmitPetitionLibraryService };
//# sourceMappingURL=submit-petition-library.js.map
